import BaseAPI from "./base/base-api";
import httpClient from "@/apis/base/axios-httpclient";

class AuditingLogAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "AuditingLog";

  insertAuditingLog(payload) {
    let request = {
      url: [this.getAPIUrl(), "insert-auditinglog"].join("/"),
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
}

export default new AuditingLogAPI();
